import { render, staticRenderFns } from "./UserComment.vue?vue&type=template&id=51becffc&lang=pug"
import script from "./UserComment.vue?vue&type=script&lang=js"
export * from "./UserComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports